import "../styles/BannerSection.scss";
import { useRef, useState } from "react";

const BannerSection = ({ video }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  if (!video || !video.video) {
    return null; // nothing to show if no video from API
  }

  return (
    <section className="banner-section">
      {/* Overlay dark background */}
      <div className="banner-overlay"></div>

      {/* Video itself */}
      <video
        ref={videoRef}
        className="banner-video"
        // poster={video.image || fimg}
        onEnded={() => setIsPlaying(false)}
      >
        <source src={video.video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay content (play button) */}
      <div className="banner-content">
        <button
          className="banner-play-btn"
          aria-label={isPlaying ? "Pause Video" : "Play Video"}
          onClick={togglePlay}
        >
          <span className="banner-play-outer">
            <span className="banner-play-inner">
              {isPlaying ? (
                <svg width="32" height="32" viewBox="0 0 32 32">
                  <rect x="10" y="8" width="4" height="16" fill="#fff" />
                  <rect x="18" y="8" width="4" height="16" fill="#fff" />
                </svg>
              ) : (
                <svg width="32" height="32" viewBox="0 0 32 32">
                  <polygon points="12,8 26,16 12,24" fill="#fff" />
                </svg>
              )}
            </span>
          </span>
        </button>
      </div>
    </section>
  );
};

export default BannerSection;
